import PropTypes from 'prop-types';
import React from 'react';
import useStyles from './Container.styles';

const Container = ({ children, className }) => {
  const classes = useStyles();

  return <div className={`${classes.container} ${className}`}>{children}</div>;
};

Container.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Container.defaultProps = {
  className: '',
};

export default React.memo(Container);
